module.exports = __webpack_public_path__ + "images/b5c447b1cd2abfd84ab4d181acb68dede89aabd66165a0c7731e7d015fd7cd67.svg";